import React, { createContext, useState } from 'react';

const TabContext = createContext();

const TabProvider = ({ children }) => {
  const [sharedData, setSharedData] = useState({});

  return (
    <TabContext.Provider value={{ sharedData, setSharedData }}>
      {children}
    </TabContext.Provider>
  );
};

export { TabProvider, TabContext };